import React from "react";
import { Container } from "react-bootstrap";

function About() {
  return (
    <Container className="art-section">
      <div className="exhibits-page">
      </div>
    </Container>
  );
}

export default About;
